module.exports = __webpack_public_path__ + "media/images/pic/gallery/2017/japan-bowl-turniej-o-puchar-japonii-b3f41a654ecf46210294314a7087e870.jpg";